import React from 'react';
import CurrencyInput from '../../../../components/CurrencyInput';
import { stringToCurrencyNumber, currencyNumberToString } from '../financialFormatters';

interface FormCurrencyFieldProps {
  id: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
  hasError?: boolean;
}

const FormCurrencyField: React.FC<FormCurrencyFieldProps> = ({
  id,
  name,
  value,
  onChange,
  disabled = false,
  placeholder = 'R$ 0,00',
  hasError = false,
}) => {
  if (disabled) {
    return (
      <input
        id={id}
        name={name}
        value={value ? stringToCurrencyNumber(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : ''}
        disabled
        readOnly
      />
    );
  }

  return (
    <CurrencyInput
      id={id}
      name={name}
      value={stringToCurrencyNumber(value)}
      onValueChange={(_formatted, _name, values) => {
        onChange(currencyNumberToString(values?.float));
      }}
      placeholder={placeholder}
      className="financial-form-field"
      hasError={hasError}
      data-field-error={hasError ? 'true' : undefined}
    />
  );
};

export default FormCurrencyField;
